module.exports = __webpack_public_path__ + "img/93.6b45c2de.jpg";